import { schema } from 'normalizr'

export const promocion = new schema.Entity('promocion', {}, { idAttribute: 'COD_PROMOCION' })

export default {
  namespaced: true,
  state: {
    list: {}
  },
  mutations: {
    setAll (state, payload) {
      let auxPromos = {}
      Object.keys(payload).map(id => payload[id]).forEach(p => {
        auxPromos[p.COD_PROMOCION] = {
          codigo: p.COD_PROMOCION,
          descripcion: p.DESC_PROMOCION,
          cod_sociedad: p.COD_SOCIEDAD != null ? p.COD_SOCIEDAD : ''
        }
      })
      state.list = Object.assign({}, auxPromos)
    },
    updateSet (state, payload) {
      state.list = Object.assign({}, state.list, payload.comercial)
    }
  },
  actions: {
  },
  getters: {
    getAll (state) {
      return Object.keys(state.list).map(id => state.list[id])
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/comerciales/promociones/store.js